(function () {
  function initGallery(root) {
    if (!root || root.dataset.gfsInit === 'true') return;
    root.dataset.gfsInit = 'true';

    if (root.dataset.animate !== 'true') return;
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-visible');
          } else {
            // 离开视口时重置，这样下次滑回来能再次触发动画
            root.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-gallery-fade-slide]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-gallery-fade-slide]');
    if (root) {
      root.dataset.gfsInit = 'false';
      root.classList.remove('is-visible');
      initGallery(root);
    }
  });
})();
